import { Loader2 } from 'lucide-react';
import clsx from 'clsx';

interface ToolCallIndicatorProps {
  toolName: string;
  status: string;
}

export const ToolCallIndicator = ({ toolName, status }: ToolCallIndicatorProps) => {
  const label = toolName.replace(/_/g, ' ');
  const isActive = status === 'executing';

  return (
    <div className="flex items-center gap-2 px-3 py-2 text-sm text-gray-500 dark:text-gray-400">
      {isActive ? (
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
      ) : (
        <div
          className={clsx(
            'h-2 w-2 rounded-full',
            status === 'completed' ? 'bg-green-500' : 'bg-red-500'
          )}
        />
      )}
      <span className="capitalize">{label}{isActive ? '...' : ''}</span>
    </div>
  );
};
